import { render, staticRenderFns } from "./userSettings.vue?vue&type=template&id=a3449c60&scoped=true"
import script from "./userSettings.vue?vue&type=script&lang=js"
export * from "./userSettings.vue?vue&type=script&lang=js"
import style0 from "./userSettings.vue?vue&type=style&index=0&id=a3449c60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3449c60",
  null
  
)

export default component.exports